/*
Soporte para el "Search"
Lo pasamos de "hook" a funcion normal.
*/

import removeAccents from '../utils/removeAccents'

type FilterField<T> = (item: T) => string

const useFilteredData = <T,>({
  array,
  filterFields,
  searchTerm,
  allowFilter,
}: {
  array: T[]
  filterFields: FilterField<T>[]
  searchTerm: string
  allowFilter: boolean
}) => {
  if (!searchTerm.trim()) return array

  if (!allowFilter) return array
  const lowerSearch = removeAccents(searchTerm.toLowerCase())

  const output = array.filter((item) =>
    filterFields
      .map((fieldFn) => removeAccents(fieldFn(item))) // Normalize and remove accents
      .filter(Boolean) // Remove undefined/null values
      .some((field) => field.toLowerCase().includes(lowerSearch))
  )

  return output
}

export default useFilteredData
